import { CTA } from "./CTA";
import { Section, SectionHeader } from "./Section";

interface CTASectionProps {
  title: string;
  description: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export function CTASection({
  title,
  description,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
}: CTASectionProps) {
  return (
    <Section variant="dark">
      <SectionHeader title={title} description={description} dark />
      <div
        style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <CTA to={primaryTo} variant="primary" size="lg">
          {primaryLabel}
        </CTA>
        {secondaryLabel && secondaryTo && (
          <CTA to={secondaryTo} variant="ghost-light" size="lg">
            {secondaryLabel}
          </CTA>
        )}
      </div>
    </Section>
  );
}
